// components/export/exportToExcel.js
import * as XLSX from "xlsx";

export const exportToExcel = (studentRecords, fileName) => {
  const wb = XLSX.utils.book_new();

  studentRecords.forEach(student => {
    if (!student || !student.scholastic) return;

    const wsData = [
      [`Unit Test Report (Class ${student.class})`],
      [`Name: ${student.name}`],
      [`Student ID: ${student.student_id}`],
      [`Class: ${student.class}`],
      ["Subjects", "Assessment Spec", "Max Marks", "Scored", "Total", "Grade"],
      ...Object.entries(student.scholastic).flatMap(([subject, assessments]) =>
        Object.entries(assessments).map(([spec, data]) => [
          subject,
          spec,
          data?.max_marks || 0,
          data?.scored || 0,
          data?.total || 0,
          data?.grade || "N/A"
        ])
      ),
      ["Observation", "Grade"],
      ...Object.entries(student.observation || {}).map(([obs, grade]) => ["", obs, "", "", "", grade]),
      ["Co-Scholastic", "Marks Scored"],
      ...Object.entries(student.co_scholastic || {}).map(([subject, marks]) => ["", subject, "", "", "", marks]),
      ["Remarks:", student.remarks || ""]
    ];

    const ws = XLSX.utils.aoa_to_sheet(wsData);
    XLSX.utils.book_append_sheet(wb, ws, student.name.replace(/ /g, "_"));
  });

  XLSX.writeFile(wb, `${fileName}.xlsx`);
};
